<template>
    <div>
        <input type="text" v-model="search" />
        <ul>
            <li v-for="(place, i) in res" :key="i">
                {{ place.matching_place_name }}
            </li>
        </ul>
    </div>
</template>

<script>
import axios from "axios";
export default {
    data() {
        return {
            search: null,
            res: [],
            accessToken:
                "pk.eyJ1IjoibW9oYW1lZDAwMSIsImEiOiJjamt1MGk5MHUwMXgwM3BxazN3cXU5M2RtIn0.JfdQvIy0cRbQOanBaL2nww",
        };
    },
    watch: {
        search(val) {
            axios
                .get(
                    `https://api.mapbox.com/geocoding/v5/mapbox.places/${this.search}.json?access_token=${this.accessToken}&autocomplete=true`
                )
                .then((res) => {
                    this.res = res.features;
                });
        },
    },
};
</script>

<style>
input {
    width: 100%;
    height: 50px;
}
.header {
    height: 500px;
    background-color: rgb(211, 209, 209);
}

.header h1 {
    text-align: center;
    font-weight: bold;
    margin-top: 160px;
}

.header h2 {
    text-align: center;
}

.pic {
    width: 100%;
}

.pic img {
    width: 80%;
    margin-top: -60px;
    margin-left: 150px;
}

.target hr {
    width: 80px;
    border-top: 3px solid #000;
}

.target h1 {
    text-align: center;
    font-weight: bolder;
}

.target p {
    text-align: center;
    font-size: 20px;
}

.text {
    display: flex;
    width: 100%;
}

.more-accuracy {
    padding: 20px;
    width: 50%;
}

.more-accuracy h1 {
    font-weight: bolder;
}

.more-accuracy p {
    font-size: 20px;
}

.standard {
    padding: 20px;
    width: 50%;
}

.standard h1 {
    font-weight: bolder;
}

.standard p {
    font-size: 20px;
}

.text .more-houses {
    padding: 20px;
    width: 50%;
}

.more-houses h1 {
    font-weight: bolder;
}

.more-houses p {
    font-size: 20px;
}

.go {
    padding: 20px;
    width: 50%;
}

.go h1 {
    font-weight: bolder;
}

.go p {
    font-size: 20px;
}

.advice {
    text-align: center;
}

.advice hr {
    width: 80px;
    border-top: 3px solid #000;
}

.advice h1 {
    font-weight: bolder;
}

.advice p {
    font-size: 20px;
}

.find-place {
    width: 100%;
    display: flex;
    padding: 20px;
}

.find-place .pic2 {
    width: 50%;
}

.find-place img {
    width: 75%;
    height: 70%;
}

.find-place .text2 {
    width: 50%;
}

.find-place h1 {
    font-weight: bolder;
}

.find-place P {
    font-size: 20px;
}

.talk-hosts {
    width: 100%;
    display: flex;
    padding: 20px;
}

.talk-hosts .pic2 {
    width: 50%;
}

.talk-hosts img {
    width: 75%;
    height: 70%;
}

.talk-hosts .text2 {
    width: 50%;
}

.talk-hosts h1 {
    font-weight: bolder;
}

.talk-hosts P {
    font-size: 20px;
}

.helping-guests {
    width: 100%;
    display: flex;
    padding: 20px;
}

.helping-guests .pic2 {
    width: 50%;
}

.helping-guests img {
    width: 75%;
    height: 70%;
}

.helping-guests .text2 {
    width: 50%;
}

.helping-guests h1 {
    font-weight: bolder;
}

.helping-guests P {
    font-size: 20px;
}

.photo {
    width: 100%;
}

.photo img {
    width: 80%;
    margin-left: 150px;
}

.photo hr {
    width: 80px;
    border-top: 3px solid #000;
}

.advice-hosts {
    text-align: center;
}

.advice-hosts h1 {
    font-weight: bolder;
}

.advice-hosts p {
    font-size: 20px;
}

.make {
    width: 100%;
    display: flex;
    padding: 20px;
}

.make .pic2 {
    width: 50%;
}

.make img {
    width: 75%;
    height: 70%;
}

.make .text2 {
    width: 50%;
}

.make h1 {
    font-weight: bolder;
}

.make P {
    font-size: 20px;
}

.add {
    width: 100%;
    display: flex;
    padding: 20px;
}

.add .pic2 {
    width: 50%;
}

.add img {
    width: 75%;
    height: 70%;
}

.add .text2 {
    width: 50%;
}

.add h1 {
    font-weight: bolder;
}

.add P {
    font-size: 20px;
}

.know {
    width: 100%;
    display: flex;
    padding: 20px;
}

.know .pic2 {
    width: 50%;
}

.know img {
    width: 75%;
    height: 70%;
}

.know .text2 {
    width: 50%;
}

.know h1 {
    font-weight: bolder;
}

.know P {
    font-size: 20px;
}

.ease-access {
    text-align: center;
}

.ease-access hr {
    width: 80px;
    border-top: 3px solid #000;
}

.ease-access h1 {
    font-weight: bolder;
}

.name {
    display: flex;
    width: 100%;
    padding: 20px;
}

.teams {
    width: 50%;
}

.teams h1 {
    font-weight: bolder;
}

.teams p {
    font-size: 20px;
}

.search {
    width: 50%;
}

.search h1 {
    font-weight: bolder;
}

.search p {
    font-size: 20px;
}

.end {
    text-align: center;
}

.end h1 {
    font-weight: bolder;
}

.questions {
    display: ;
}
</style>
